@if (externalLink) {
  <a
    class="tool-link"
    target="_blank"
    [href]="externalLink"
    [matTooltip]="tooltip"
    [matTooltipShowDelay]="1000"
  >
    <div class="tool-link-label">
      <mat-icon>launch</mat-icon> {{ toolLabel }}
    </div>
  </a>
} @else {
  <button
    type="button"
    class="tool-link"
    [matTooltip]="tooltip"
    [matTooltipShowDelay]="1000"
    (click)="defaultClick.emit($event)"
    (auxclick)="secondaryClick.emit()"
    (contextmenu)="secondaryClick.emit()"
  >
    <div class="tool-link-label">
      <mat-icon>launch</mat-icon> {{ toolLabel }}
    </div>
  </button>
}
